import { render, staticRenderFns } from "./purchaseReport.vue?vue&type=template&id=2f1e2c06"
import script from "./purchaseReport.js?vue&type=script&lang=js&external"
export * from "./purchaseReport.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports